import { dishonestCurrentUser$ as currentUser$ } from './currentUser/currentUser$';
import { map, Observable } from 'rxjs';
import { getDefaultLocale, getLocale, Locale } from '@ardoq/locale';
import { distinctUntilChanged, shareReplay } from 'rxjs/operators';
import { PersonalSetting } from '@ardoq/api-types';

export const locale$: Observable<Locale> = currentUser$.pipe(
  map(user => {
    const usersLocale = user.settings?.[PersonalSetting.LOCALE];
    return getLocale(usersLocale) ?? getDefaultLocale();
  }),
  distinctUntilChanged(),
  shareReplay({ refCount: true, bufferSize: 1 })
);
